import { SupportAttachment } from './general-types/support-ticket';

export const SUPPORT_ATTACHMENT_ACCEPT =
  'image/png,image/jpeg,image/webp,image/gif,.pdf,application/pdf';

export const MAX_SUPPORT_ATTACHMENTS = 5;
export const MAX_SUPPORT_ATTACHMENT_BYTES = 10 * 1024 * 1024;

export function isImageAttachment(fileType: string): boolean {
  return fileType.startsWith('image/');
}

export function isAllowedSupportAttachment(file: File): boolean {
  if (file.size > MAX_SUPPORT_ATTACHMENT_BYTES) {
    return false;
  }

  return file.type.startsWith('image/') || file.type === 'application/pdf';
}

export function isSupportImageAttachment(attachment: SupportAttachment): boolean {
  return isImageAttachment(attachment.fileType);
}
